<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-xs">
          <q-card-section class="q-py-xs">
            <div v-if="nmInterface === 'gravar'" class="crud-title">
              <translate>NEW_REGISTRATION</translate>
            </div>
            <div v-else-if="nmInterface === 'alterar'" class="crud-title">
              <translate>UPDATE</translate>
            </div>
            <div v-else-if="nmInterface === 'detalhar'" class="crud-title">
              <translate>VIEW_REGISTRATION</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-px-lg container-vehicle">
            <span v-if="elements.length == 1">
              <jt-dynamic-form
                ref="dynamicForm"
                :inputs="inputs"
                :relacionamentos="elements[0].relacionamentos"
                :model="elements[0].dadosForm"
                :interface="elements[0].nmInterface"
                form-class="form dynamic"
                @search-found="selections"
              />
            </span>
            <div class="row container-vehicle-image">
              <div class="col-4 q-pr-md">
                <jt-input
                  ref="input"
                  name="jtsearch-input"
                  :type="type"
                  :float-label="$gettext('CAPACITY')"
                  :required="true"
                  :readonly="true"
                  :stack-label="$gettext('CAPACITY')"
                  v-model="elements[0].dadosForm.weightCapacity"
                />
              </div>
              <div class="col-1 full-height justify-start">
                <q-btn
                  color="grey-3"
                  :inverted="inverted"
                  :disable="disable"
                  class="btn q-py-xs"
                  @click="
                    () => {
                      flModal = true
                    }
                  "
                >
                  <q-icon size="2.3em" color="primary" name="search" />
                </q-btn>
              </div>
              <truck-weight-capacity-search-modal
                ref="truck_weight_capacity_search_modal"
                :nm-interface="nmInterfaceSearch"
                :filter-params="{}"
                :multiselect="false"
                class="fill-height-or-more full-height"
                @selection="onSearchDataFound"
                @changeModal="onChangeModal"
                :fl-modal="flModal"
              />
              <div
                class="col-2 text-left"
                v-if="showImage && elements[0].dadosForm.truckWeightCapacity"
              >
                <img class="vehicleImage" :src="src()" />
              </div>
            </div>
          </q-card-section>
          <q-card-section class="q-px-lg container-vehicle-composition">
            <span v-if="elements.length == 1">
              <jt-dynamic-form
                ref="dynamicFormComp"
                :inputs="prepareInputs(inputsComposition)"
                :relacionamentos="elements[0].relacionamentos"
                :model="elements[0].dadosForm"
                :interface="elements[0].nmInterface"
                form-class="form dynamic"
                @composition-button-click="onCompositionButtonClick"
              />
            </span>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div
      v-if="forms[0] && forms[0].buttons.length > 0"
      class="row full-width q-col-gutter-x-lg justify-center q-mt-md"
    >
      <div class="col-lg-2 col-md-2">
        <q-btn class="full-width" color="grey-7" @click="limparFormVehicle">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-2"
      >
        <q-btn class="full-width" color="info" @click="actionButton(button)">
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
    <composition-multi-form-modal
                v-show="showFormCurrentCarrierVehicle"
                ref="carrierVehicles"
                titleTopBar="ADD_MORE_CARRIER"
                addOneMoreItemButtonLabel="CARRIER"
                cssname="vehicle-page"
                :form="formConfig"
                :model="elements[0].dadosForm"
                :composicaos="elements[0].dadosForm.carrierVehicles"
                :nr-linha-selecionada="nrLinhaSelecionada"
                :fl-main-crud-in-change="isEditVehicle"
                :fl-composicao-alteracao="editMode"
                :afterPerformItems="afterPerformItems"
                :non-changeable-fields="nonChangeableFields"
              />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm, JtInput } from 'jtech-webcomps'
import { repository } from 'jtech'
import * as imageNotFound from '../../../assets/imageNotFound.png'
import CompositionMultiFormModal from '../../../components/composition-multi-form-modal/CompositionMultiFormModal'
import TruckWeightCapacitySearchModal from './../truckWeightCapacity/TruckWeightCapacitySearchModal'

const { page, modal } = JtCrud

@Component({
  mixins: [page],
  name: 'Vehicle',
  components: { JtDynamicForm, JtInput, TruckWeightCapacitySearchModal, CompositionMultiFormModal },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
class VehiclePage extends Vue {
  nmInterface = null
  truckImage = null
  showImage = false
  flModal = false
  editMode = false
  nrLinhaSelecionada = null
  showFormCurrentCarrierVehicle = false
  customCompositions = ['carrierVehicles']
  nmInterfaceSearch = 'truckWeightCapacity.pesquisar'
  nonChangeableFields = []

  async mounted () {
    this.nmInterface = this.elements[0].nmInterface.split('.')[1]
    if (this.elements[0].dadosForm.truckWeightCapacity) {
      await this.findImage()
    }
    this.setVehicleModelInput()
  }

  prepareInputs (_inputs) {
    this.prepareCompositionsInputs(_inputs)

    return _inputs
  }

  prepareCompositionsInputs (_inputs) {
    _inputs.forEach((_input) => {
      if (_input.model == 'person' && _input.type != 'text') {
        _input.type = 'person_search'
      }
      if (this.customCompositions.includes(_input.model)) {
        _input.allowCustomEditModal = true
      }
    })
  }

  afterPerformItems () {
    this.showFormCurrentCarrierVehicle = false
    this.$refs.carrierVehicles.hide()
  }

  addCarriers (eventObject) {
    this.editMode = false
    this.openMultiFormModal(eventObject)
  }

  editCarrier (eventObject) {
    this.editMode = true
    this.nrLinhaSelecionada = eventObject.nrLinhaSelecionada
    this.openMultiFormModal(eventObject)
  }

  onCompositionButtonClick (eventObject) {
    const { button: clickedButton } = eventObject

    switch (clickedButton.name) {
      case 'icAdicionarComposicao':
        this.addCarriers(eventObject)
        break
      case 'icAlterarComposicao':
        this.editCarrier(eventObject)
        break
      case 'icRemoveRecordOnComposition':
        this.removeCarrier(eventObject)
        break
      default:
        break
    }
  }

  removeResidue (eventObject) {
    const { compositionId, params } = eventObject
    const clickedIndex =
      params && (params.__index || params.__index === 0)
        ? eventObject.params.__index
        : null
    const newCarriersArray = []
    this.elements[0].dadosForm[compositionId].forEach((carrier) => {
      const isAlreadyASavedRecord = carrier.id || carrier.id === 0
      if (isAlreadyASavedRecord || carrier.__index !== clickedIndex) {
        carrier.__index = newCarriersArray.length
        newCarriersArray.push(carrier)

        if (carrier.__index === clickedIndex && isAlreadyASavedRecord) {
          console.error(
            'This button can\'t be used when the process is different from add a new vehicle'
          )
        }
      }
    })
    this.elements[0].dadosForm[compositionId] = newCarriersArray
    this.nrLinhaSelecionada = null
  }

  openMultiFormModal (eventObject) {
    const { compositionId, formConfig } = eventObject

    if (this.customCompositions.includes(compositionId)) {
      this.formConfig = formConfig

      if (compositionId === 'carrierVehicles') {
        this.showFormCurrentCarrierVehicle = true
      }

      this.$nextTick(() => {
        this.$refs[compositionId.substring(0, compositionId.length)].show()
      })
    }
  }

  async findImage () {
    const param = { id: this.elements[0].dadosForm.truckWeightCapacity }
    const { registros } = await repository.resolveDatatableModel(
      'truckWeightCapacity.pesquisar',
      param
    )
    this.truckImage = registros[0].imageGrid
    this.showImage = true
  }

  onChangeModal (newModal) {
    this.flModal = newModal
  }

  onClearHandler () {
    this.showImage = false
    this.truckImage = null
    this.elements[0].dadosForm.truckWeightCapacity = null
    this.elements[0].dadosForm.weightCapacity = ''
  }

  async fetchData () {
    if (!this.elements[0].dadosForm.weightCapacity) {
      return
    }
    try {
      const { textField, codeField, idField } = await repository.resolveSearch(
        'truckWeightCapacity.pesquisarSelecao',
        {
          code: this.elements[0].dadosForm.weightCapacity,
          ...this.extraParams
        }
      )
      this.elements[0].dadosForm.truckWeightCapacity = idField
      this.elements[0].dadosForm.weightCapacity = codeField
      await this.findImage()
    } catch (e) {
      this.onClearHandler()
    }
  }

  onSearchDataFound (data) {
    if (data) {
      this.flModal = false
      this.elements[0].dadosForm.truckWeightCapacity = data.id
      this.elements[0].dadosForm.weightCapacity = data.weightCapacity
      this.showImage = true
      this.truckImage = data.imageGrid
    } else {
      this.onClearHandler()
    }
  }

  actionButton (button) {
    const capacityValidation = this.$refs.input.validate()
    if (
      !this.isButtonValidForm(button) ||
      (this.isValidForm() && capacityValidation)
    ) {
      this.$emit('action-button', button, this.getParams(), this)
    } else {
      this.$emit('show-message', 'warning', 'REQUIRED_FIELDS_NOT_FILLED', this)
    }
  }

  src () {
    if (this.truckImage) return 'data:image;base64,' + this.truckImage
    return imageNotFound
  }

  get inputs () {
    return this.elements[0].inputs.filter(
      (ci) => ci.type !== 'COMPOSICAO' && ci.type !== 'SEARCH_MODAL'
    )
  }

  get isAddNewVehicle () {
    return this.nmInterface === 'gravar'
  }

  get isEditVehicle () {
    return this.nmInterface === 'alterar'
  }

  get inputsComposition () {
    return this.elements[0].inputs.filter((ci) => ci.type === 'COMPOSICAO')
  }

  limparFormVehicle () {
    this.$refs.dynamicForm.resetForm()
    this.$refs.dynamicFormComp.resetForm()
    this.$refs.input.resetValidation()
    this.onClearHandler()
    this.elements[0].dadosForm = { carrierVehicles: [] }
  }

  isValidForm () {
    const form1 = this.$refs.dynamicForm.isValidForm()
    const form2 = this.$refs.dynamicFormComp.isValidForm()
    return form1 && form2
  }

  setVehicleModelInput () {
    const { relacionamentos, dadosForm } = this.elements[0]
    const { vehicleModel } = relacionamentos
    if (vehicleModel.length === 1) {
      dadosForm.vehicleModel = vehicleModel[0].value
    }
  }
}

export default VehiclePage
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

#vehicle-page{
  .containerForm-add{
    #scroll-area {
      height: calc(10vh - 12px)!important;
    }
  }
}
::v-deep {
  .container-vehicle {
    .dynamic-form #scroll-area {
      height: calc(18vh - 0px) !important;
    }
  }

  .container-vehicle-composition {
    .dynamic-form #scroll-area {
      height: calc(50vh - 0px) !important;
    }
  }

  .container-vehicle-image{
    height: calc(5vh - 0px) !important;
  }
  @media only screen and (max-height: 870px) {
    .container-vehicle {
    .dynamic-form #scroll-area {
      height: calc(18vh - 0px) !important;
      }
    }
  }

  @media only screen and (max-height: 790px) {
    .container-vehicle {
    .dynamic-form #scroll-area {
      height: calc(20vh - 0px) !important;
    }
  }
  }

  @media only screen and (max-height: 700px) {
    .container-vehicle {
    .dynamic-form #scroll-area {
      height: calc(23vh - 0px) !important;
    }
  }
}

.vehicleImage {
  height: 50px;
  width: auto;
}

}
</style>
